
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: '#dcdcdc',
    padding: '1%',
  },

  items: {
    padding: '1%',
    display:'flex',
    flexDirection:'row'
  },

  item_header: {
    fontWeight: 600,
    paddingLeft: '10%',
    width:'40%'
  },

  item_body: {
    padding: '6px ',
    width:'60%'
  },
  button:{
    height: '35px',
    width: '125px',
    backgroundColor: '#c6ff00',
    padding: '2%',
    marginLeft: '160px',
    alignItem: 'center',
    marginTop: '1%'
  },

  main_header: {
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#32B6A7',
  },
   sub_header: {
    marginBottom: '3%',
    backgroundColor: '#32B6A7',
    marginTop: '1%',
  },
  fixture_list: {
    marginBottom: '1%',
    backgroundColor: '#39435c',
    padding: '1%',
    alignSelf: 'center',
    marginLeft: '105px',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '50%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/scheduleDemo/style.js